// removed by extract-text-webpack-plugin
module.exports = {"container":"_3GRz","content":"_1ktc","authorContainer":"_2Z1y","name":"_27oZ","quote":"SQaE","image":"_1wvz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/CompanyInformation/Quote/styles.scss
// module id = 530
// module chunks = 0